import { combineReducers } from '@reduxjs/toolkit';

import unsubscribe from './unsubscribe';

/**
 * @typedef {{
 *  unsubscribe: import('./unsubscribe').UnsubscribeState
 * }} LeadsState
 */

export default combineReducers({
  unsubscribe,
});
